module.exports = __webpack_public_path__ + "img/LTE:OK - WLAN:ERR - PopOver.3ce4a010.jpg";